import { render, staticRenderFns } from "./PrivilegeDetail.vue?vue&type=template&id=b8ba488c&"
import script from "./PrivilegeDetail.vue?vue&type=script&lang=ts&"
export * from "./PrivilegeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports